<template>
  <div>
    <rubric-version-status-badge :status="params.data.status" />
  </div>
</template>

<script lang="js">
import Vue from 'vue'
import RubricVersionStatusBadge from "./RubricVersionStatusBadge"

export default Vue.extend({
  components: {
    RubricVersionStatusBadge
  },
})
</script>
